/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
'use strict';
//Object.assign polyfill
if (typeof Object.assign !== 'function') {
  Object.assign = function(target, varArgs) { // .length of function is 2
    if (target == null) { // TypeError if undefined or null
      throw new TypeError('Cannot convert undefined or null to object');
    }

    var to = Object(target);

    for (var index = 1; index < arguments.length; index++) {
      var nextSource = arguments[index];

      if (nextSource !== null) { // Skip over if undefined or null
        for (var nextKey in nextSource) {
          // Avoid bugs when hasOwnProperty is shadowed
          if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
    return to;
  };
}

(function($, undefined) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  //define this before everything else so jshint doesn't thrown error
  var SageGlobals;


  // Google event tracker code. Currently setup to use GA vs GTM
  window.GATracker = window.GATracker || { subs: {} };

  (function(GATracker) {
    var gat = GATracker;

    gat.sub = function(label, func) {
      if( (label && func) && typeof this.subs[label] === 'undefined' ) {
        this.subs[label] = func;
      }
    };

    gat.isInt = function(value) {
      return !isNaN(value) && parseInt(Number(value)) === value && !isNaN(parseInt(value, 10));
    };

    gat.gatPush = function(eventObject) {
      //GA event
      ga('send', {
        hitType: eventObject.hitType,
        eventCategory: eventObject.eventCategory,
        eventAction: eventObject.eventAction,
        eventLabel: eventObject.eventLabel,
        eventValue: eventObject.eventValue
      });
    };

    gat.consumeEvent = function($this, callback) {
      var preFunction = $this.data('gatpre');
      if( preFunction && typeof gat.subs[preFunction] === 'function' ) {
        gat.subs[preFunction]($this);
      }

      gat.gatPush({
        hitType: 'event',
        eventCategory: $this.data('gatcategory') || this,
        eventAction: $this.data('gataction') || 'click',
        eventLabel: $this.data('gatlabel') || '',
        eventValue: gat.isInt($this.data('gatvalue')) ? $this.data('gatvalue') : 0
      });

      if( typeof callback !== 'undefined' && typeof callback === 'function' ) {
        callback();
      }
    };
    //To disable page source Disable CTRL U and Right Click
//      if (jQuery('body').hasClass('logged-in')===false) { console.log('disable');
//           document.onkeydown = function(e) {
//           if (e.ctrlKey && e.keyCode === 85) {
//                return false;
//            }
//          };
//          jQuery('body').contextmenu(function() {
//              return false;
//          });
// }
    $(document).on('click', '[data-gat~="click"]', function(e) {
      var $this = $(this),
          targetProperty = $this.attr('target'),
          callback;

      if( this.nodeName === 'A' ) {
        e.preventDefault();

        var target = (targetProperty && targetProperty.match(/^_(self|parent|top|blank)$/i)) ? targetProperty : false;
        var link = $this.attr('href');

        callback = (function(link, target) {
          if(target !== false) {
            window.open(link, target);
          }
          else {
            window.location.href = link;
          }
        })(link, target);
      }

      gat.consumeEvent( $(this), callback);
    });

    $(document).on('change', '[data-gat~="change"]', function() {
      var $this = $(this),
          callbackFuncName = $this.data('gatcallback'),
          callback = null;

      if(callbackFuncName && typeof gat.subs[callbackFuncName] === 'function') {
        callback = (function($this) {
          gat.subs[callbackFuncName]($this);
        })($this);
      }

      gat.consumeEvent($(this), callback);
    });

    $(document).on('mouseover', '[data-gat~="mouseover"]', function() {
      gat.consumeEvent( $(this) );
    });

    $(document).on('submit', '[data-gat~="submit"]', function() {
      gat.consumeEvent( $(this) );
    });

  })(window.GATracker);

  var _Lib = {
    sendRequest: function(action, endPoint, data) {
      var url = action === 'GET' ? '/lib/'+ endPoint + '?' + data : '/lib/' + endPoint,
          dataObj = action === 'GET' ? '' : data;

      return new Promise( function (resolve, reject) {
        $.ajax({
          method: action,
          url: url,
          dataType: 'json',
          data: dataObj
        })
            .done(function (data) {
              if(data === null) {
                reject(new Error('result is undefined'));
              }
              else if(data.hasOwnProperty('success') && data.success === 'false') {
                reject(data);
              }
              else {
                resolve(data);
              }
            })
            .fail(function (jqXHR) {
              reject({
                status: jqXHR.status,
                statusText: jqXHR.statusText,
                responseText: jqXHR.responseText
              });
            });

      });
    }
  };

  var _Auth0 = {
    sendRequest: function(action, endPoint, data) {
      return new Promise( function (resolve, reject) {
        $.ajax({
          method: 'POST',
          url: '/lib/request.php',
          dataType: 'json',
          data: data,
          headers: {
            'X-request-action': action,
            'X-request-endpoint': endPoint,
            'X-request-platform': 'AUTH0',
            'X-request-nonce': $('#request-nonce').val()
          }
        })
            .done(function (data) {
              resolve(data);
            })
            .fail(function (jqXHR) {
              SageGlobals.log({
                errorSeverity: 'WARNING',
                error: jqXHR.responseJSON,
                payload: data,
                description: 'Exception during _Auth0.sendRequest'
              });

              reject(jqXHR.responseJSON);
            });

      });
    },

    query: function(queryParams) {
      var qstring = 'fields=' + encodeURIComponent(queryParams.fields) || 'id';
      qstring += '&email=' + encodeURIComponent(queryParams.searchValues) || '';

      return _Auth0.sendRequest('GET', 'users-by-email', qstring);

      // return _Auth0.sendRequest('GET', 'users', qstring + '&search_engine=v2');
    },

    sendVerificationEmail: function(userId) {
      var data = {
        user_id: userId
      };

      return _Auth0.sendRequest('POST', 'jobs/verification-email', data);
    },

    getImpersonationUrl: function(userId, imposterId, nonce, redirectUrl) {
      var data = {
        user: userId,
        imposter: imposterId,
        nonce: nonce,
        redirect: redirectUrl
      };

      return _Lib.sendRequest('POST', 'impersonate.php', data);
    }
  };

  function getSalesforceAccessToken() {
    var currentDomain = window.location.origin;
    // Construct the token URL using the current domain
    var tokenUrl = currentDomain + "/app/themes/sage-child/lib/leadSearch.php";
    console.log("Token URL:", tokenUrl); // Log the token URL

    return $.ajax({
      url: tokenUrl,
      method: 'GET',
      data: { action: 'getAccessToken' },
      dataType: 'json'
    }).then(function(response) {
      console.log("Token Response:", response); // Log the token response
      return response;
    }).catch(function(error) {
      console.error("Error getting access token:", error);
      console.error("Error details:", JSON.stringify(error, null, 2));
      throw error;
    });
  }

// Generic function for Salesforce API calls
  function callSalesforceApi(endpoint, method, data) {


    return $.ajax({
      url: '/wp/wp-admin/admin-ajax.php',
      method: 'POST',
      data: {
        action: 'salesforce_api_request',
        endpoint: endpoint,
        method: method,
        data: data
      },
      dataType: 'json'
    });
  }


  var _Boomi = {
    sendRequest: function(action, endPoint, data, additionalHeaders) {
      var headers  = {
        'X-request-action': action,
        'X-request-endpoint': endPoint,
        'X-request-platform': 'BOOMI',
        'X-request-nonce': $('#request-nonce').val()
      };

      headers = Object.assign(headers, additionalHeaders);

      return new Promise( function (resolve, reject) {
        $.ajax({
          method: 'POST',
          url: '/lib/request.php',
          dataType: 'json',
          data: data,
          headers: headers
        })
            .done(function (data) {
              resolve(data);
            })
            .fail(function (jqXHR) {
              SageGlobals.log({
                errorSeverity: 'WARNING',
                error: jqXHR.responseJSON,
                payload: data,
                description: 'Exception during _Boomi.sendRequest'
              });

              reject(jqXHR.responseJSON);
            });

      });
    }
  };

  SageGlobals = {

    //common vars
    formClasses: '',
    formStateClasses: {
      success: 'is_success',
      error: 'is_error'
    },
    invalidRedirects:[],
    GENERIC_ERROR_MSG: 'Something went wrong. Please try again later.',
    DOWN_ARROW_KEY_CODE: 40,
    UP_ARROW_KEY_CODE: 38,
    ESC_KEY_CODE: 27,
    ENTER_KEY_CODE: 13,
    TAB_KEY_CODE: 9,

    log: function(errorData) {
      var defaults = {
        errorSeverity: 'NOTICE',
        error: '',
        payload: '',
        scriptLocation: window.location.pathname,
        description: '',
        nonce: $('#log-nonce').val()
      };

      var mergedData = Object.assign(defaults, errorData);
      _Lib.sendRequest('POST', 'log.php', mergedData).catch(function(response) {
      });
    },

    //taken from https://davidwalsh.name/javascript-debounce-function
    debounce: function(func, wait, immediate) {
      var timeout;
      return function() {
        var context = this, args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) {
            func.apply(context, args);
          }
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
          /* jshint ignore:start */
          func.apply(context, args);
          /* jshint ignore:end */

        }
      };
    },

    getTimeStamp: function() {
      return moment().tz('America/New_York').format('ggggMMDD HHmmss.SSS');
    },

    //basic check for absolute urls. Not concerned about any other url format except http e.g. ftp etc.
    isAbsoluteUrl: function(url) {
      return url.charAt(0) !== '/';
    },

    formatRedirectUrl: function(url) {
      if(SageGlobals.isAbsoluteUrl(url)) {
        return SageGlobals.verifyExternalUrl(url) ? url : '/';
      }
      else {
        return url;
      }
    },

    getHostName: function(url) {
      var match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
      if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
        return match[2];
      }
      else {
        return null;
      }
    },

    parseDomain: function(url) {
      var hostName = SageGlobals.getHostName(url);
      var domain = hostName;

      if (hostName !== null) {
        var parts = hostName.split('.').reverse();

        //only work on TLD's without a .
        //co.uk would fail
        if (parts !== null && parts.length > 1) {
          domain = parts[1] + '.' + parts[0];
        }
      }

      return domain;
    },

    verifyExternalUrl: function(url) {
      return CONFIG.WHITELISTED_DOMAINS.indexOf(SageGlobals.parseDomain(url)) !== -1;
    },

    UserLoggedInViewModel: function(isLoggedIn) {
      var self = this;
      self.isLoggedIn = ko.observable(isLoggedIn);
    },

    resetPasswordViewModal: function(email) {
      var self = this;
      SageGlobals.formViewModel.call(self);

      self.connectionValid = ko.observable(false);
      self.email = ko.observable();
      self.submit('Reset My Password');

      self.validate = function() {
        self.userEmail = email !== undefined ? email : self.email();

        return self.validateEmail(self.userEmail);
      };

      self.resetPassword = function() {
        /* jshint ignore:start */
        var WebAuth = new auth0.WebAuth({
          domain:         CONFIG.AUTH0_DOMAIN,
          clientID:       CONFIG.AUTH0_CLIENT_ID,
          responseType:   'token id_token',
          redirectUri:    CONFIG.AUTH0_REDIRECTION_URL + '?connection=' + CONFIG.connection.DB
        });

        if(self.preSubmit()) {
          WebAuth.changePassword({
            connection: CONFIG.connection.DB,
            email: self.userEmail
          }, function (err, response) {
            if(err) {
              self.setMessage('error', self.errorClass, err);
            }
            else {
              //return custom msg on success
              if($('#logout').length !== 0 && $('.user-profile-link').length !== 0){
                self.setMessage('success', self.successClass, 'We\'ve just sent you an email to reset your password.');
              } else {
                self.setMessage('success', self.successClass, 'If your email address is registered in our system, you will receive an email shortly to help you reset your password. If you do not receive an email within 10 minutes, please contact the NPPGov customer service team at <a href="mailto:customerservice@nppgov.com" style=" text-decoration: underline; font-weight: 600; ">customerservice@nppgov.com</a> or <a href="tel:877-329-8847" style=" text-decoration: underline; font-weight: 600; ">877-329-8847</a> for assistance.');
              }
            }
          });
        }
        /* jshint ignore:end */
      };
    },
    dynamicCategoryList: function() {
      var self = this;
      var currentDomain = window.location.origin;
      // Construct the token URL using the current domain
      var tokenUrl = currentDomain + "/app/themes/sage-child/lib/leadSearch.php";
      var values="Dependent_Picklist_Field=Lead.Organization_Category__c&getIndustryList=Yes";
      jQuery.ajax({
        url: tokenUrl,
        type: "POST",
        dataType: 'text',
        data: values,
        success: function(data) {
          jQuery('.busi_industry').empty();
          jQuery('.busi_industry').append('<option value="">--Select Industry--</option>');
          var mainIndustry=Object.keys(JSON.parse(data));
          mainIndustry=mainIndustry.sort();
          jQuery.each(mainIndustry, function(key, value) {
            var industryArr = value.split('+');
            var $option = jQuery("<option/>", {
              value: industryArr[0],
              text: industryArr[1]
            });
            jQuery('.busi_industry').append($option);
            //jQuery(".busi_subindustry").prop("disabled", true);
          });

          jQuery(".busi_industry").change(function (e) {
            var id = jQuery(this).attr("id");
            jQuery('.busi_subindustry').empty();

            //jQuery(".busi_subindustry").prop("disabled", false);
            jQuery('.fdid').hide();
            jQuery('.stud_count').hide();
            var industry=jQuery("#"+id+".busi_industry option:selected" ).val()+"+"+ jQuery("#"+id+".busi_industry option:selected" ).text() ;
            if(jQuery("#"+id+".busi_industry option:selected" ).val()==='Education ') {jQuery('.stud_count').show();} else{ jQuery('.stud_count').hide();}
            if(jQuery("#"+id+".busi_industry option:selected" ).val()==='Fire & Rescue ') {jQuery('.fdid').show();} else{ jQuery('.fdid').hide();}
            console.log(industry);
            var subIndustry=JSON.parse(data)[industry];
            console.log(subIndustry);
            //subIndustry=subIndustry.sort();
            subIndustry = Object.keys(subIndustry).sort().reduce((r, k) => (r[k] = subIndustry[k], r), {});
            console.log(subIndustry);
            jQuery('.busi_subindustry').append('<option value="">--Select Sub Industry--</option>');

            jQuery.each(subIndustry, function(key, value) {
              var $option = jQuery("<option/>", {
                value: value,
                text: key
              });
              jQuery('.busi_subindustry').append($option);
            });

          });
        }
      });
    },

    formViewModel: function() {
      var self = this;

      self.errorClass = SageGlobals.formStateClasses.error;
      self.successClass = SageGlobals.formStateClasses.success;

      self.messages = ko.observableArray();
      self.messageState = ko.observable('');

      self.submit = ko.observable('Submit');
      self.formSubmitted = ko.observable(false);
      self.formWorking = ko.observable(false);
      self.state = ko.observable();
      self.honeyPot = ko.observable('');
      self.validateMessage = {
        tel: 'Telephone number needs to be in the format of 555-555-5555',
        email: 'Please enter an email address.',
        require: 'Please fill out this field.',
        requireselect: 'Please select an option.',
        confirmPassword: 'Your passwords do not match',
        confirmEmail: 'Your email addresses do not match',
        url: 'Please enter a URL',
        postalCode: 'Please enter a valid postal code',
        password: 'Password must be at least 8 characters in length and contain 1 lowercase letter, 1 uppercase letter and 1 number'
      };
      self.inputClasses = {
        focus: 'is-focus',
        valid: 'is-valid',
        dirty: 'is-dirty'
      };

      //validation functions
      self.validateRequire = function(value) {
        return value !== '';
      };

      self.validateTel = function(value) {
        var telRe = /^\(?[\d]{3}\)?(\s|-|\.)?[\d]{3}(\s|-|\.)?[\d]{4}$/;
        return telRe.test(value);
      };

      self.validateTelOpt = function(value) {
        return self.validateTel(value) || value === '';
      };

      self.validateEmail = function(value) {
        //regex per HTML5 spec
        var emailRe = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        return emailRe.test(value);
      };

      self.validateEmailOpt = function(value) {
        return self.validateEmail(value) || value === '';
      };

      self.validateUrl = function(value) {
        var urlRe = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/;
        return urlRe.test(value);
      };

      self.validateUrlOpt = function(value) {
        return self.validateUrl(value) || value === '';
      };

      self.validatePostalCode = function(value, country) {
        if(country === undefined) {
          return value !== '';
        }
        else {
          var postalCodeRe = country === 'CA' ? /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/ : /(^\d{5}(-\d{4})?$)/;
          return postalCodeRe.test(value);
        }
      };

      self.validatePassword = function(value) {
        var passwordRe = /^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])).{8,}$/;
        return passwordRe.test(value);
      };

      self.validateConfirm = function(value) {
        return value[0] === value[1];
      };
      self.validateConfirmEmail = function(value) {
        if(value[0] !== value[1]) {
          jQuery("#gov-registration .button--submit").prop("disabled", true);
          jQuery("input[name=email-confirm]").addClass('is-invalid user-error');
          return false;
        } else {
          jQuery("#gov-registration .button--submit").prop("disabled", false);
          jQuery("input[name=email-confirm]").removeClass('is-invalid user-error');
          return true;
        }
      };

      //internal validate function to allow for extending on a VM basic

      self.validate = ko.pureComputed(function() {
        return true;
      });

      //format functions
      self.formatTel = function(val) {
        var reFormat = /([\d]{3})([\d]{3})([\d]{4})/,
            strippedTel = val.replace(self.telReplaceRe, '');

        return strippedTel.replace(reFormat, '($1) $2-$3');
      };

      self.formatPasscode = function(val) {
        return val.toUpperCase();
      };

      //functions to process validation/focus feedback on form elements
      //msg, validateFunction and value are optional for non-required inputs
      self.updateInput = function(event, element, className, msg, validateFunction, value, extraValues) {
        if(event === 'blur') {
          $(element).removeClass(className);
        }
        else if(event === 'focus') {
          $(element).addClass(className);
        }

        self.processInput(element, msg, validateFunction, value, extraValues);
      };

      //handles any validation logic for the form element
      self.processInput = function(element, msg, validateFunction, value, extraValues) {
        //trigger autofill check for Safari to keep Knockout in sync
        $(element).checkAndTriggerAutoFillEvent();
        self.setValidationMessage(element, msg, validateFunction, value, extraValues);

        //set dirty class on element to handle UI rendering of invalid state
        if(!$(element).hasClass(self.inputClasses.dirty)) {
          $(element).addClass(self.inputClasses.dirty);
        }
      };

      self.validateRegEmail = function(event, element, className, msg, validateFunction, value) {
        console.log(value);
        var email=value;
        var rejectList =  [ "itisverywell.com", "example.com", "thefmails.com" , "yandex.com" ,".ru" ,".top", ".de",".xyz",".ua",".pl",".lv",".website"];
        var splitArray = email.split('@'); // To Get Array
        var dotemail=email.substring(email.lastIndexOf("."));
        var val2=jQuery("input[name=email-confirm]").val();
                 if(rejectList.indexOf(splitArray[1]) >= 0 || rejectList.indexOf(dotemail) >= 0 ) {
          if(value===val2){
                     jQuery("input[name=email-confirm]").removeClass('is-invalid user-error is-focus is-dirty');
                     jQuery(".reg_email .email_ck").removeClass('is-invalid user-error is-focus is-dirty');
            jQuery("#gov-registration .button--submit").prop("disabled", true);
                     return true;
          } else{
            jQuery(".reg_email .email_ck").addClass('is-invalid user-error');
            jQuery("#gov-registration .button--submit").prop("disabled", true);
            return false;
          }
        } else {
          if(value!==val2){
            jQuery("#gov-registration .button--submit").prop("disabled", true);
            return false;
          } else {
            jQuery("#gov-registration .button--submit").prop("disabled", false);
                     jQuery(".reg_email .email_ck").removeClass('is-invalid user-error is-focus is-dirty');
                     jQuery(".email_ck1").removeClass('is-invalid user-error is-focus is-dirty');
            return true;
          }
        }
      };

      //set custom validation message for element
      self.setValidationMessage = function(element, msg, validateFunction, value, extraValues) {
        //if element is <select> add :invalid class to select wrapper
        if(typeof validateFunction === 'function') {
          //
          if(!validateFunction(value, extraValues)) {
            element.setCustomValidity(msg);

            if($(element).hasClass('is-dirty')) {
              $(element).addClass('is-invalid');
              if($(element).data('customvalidate') === true) {
                $(element).siblings('.field__validation').text(msg);
              }
            }
          }
          else {
            $(element).removeClass('is-invalid');
            element.setCustomValidity('');
            if($(element).data('customvalidate') === true) {
              element.setCustomValidity('');
              $(element).siblings('.field__validation').text('');
            }
          }
        }

      };

      self.clearValidationMessage = function(element) {
        element.setCustomValidity('');
      };

      self.resetMessages = function() {
        self.messages([]);
      };

      self.setMessage = function(status, statusClass, message) {
        self.setWorking(false);
        self.messages.push({
          status: status,
          statusClass: statusClass,
          message: message
        });
      };

      self.setState = function(val) {
        self.state(val);
        self.resetMessages();
      };

      self.setWorking = function(state) {
        self.formWorking(state);
      };

      self.preSubmit = function() {
        //empty message array to reset
        self.resetMessages();

        //ignore all form submit events while form is processing
        if(self.formWorking()) {
          return false;
        }

        if(!self.validate()) {
          self.setMessage('error', self.errorClass, 'Please fill out all required fields correctly.');
          return false;
        }

        //set form working states
        self.formSubmitted(true);
        self.setWorking(true);

        //ignore request if honeypot is triggered by bot
        if(self.honeyPot() !== '') {
          self.setWorking(false);
          return false;
        }
        else {
          return true;
        }
      };
    },

    stateCountryViewModel: function() {
      var self = this;

      self.state = ko.observable('');
      self.stateDisplay = ko.observable('');
      self.country = ko.observable('');
      self.countryDisplay = ko.observable('');

      //when country changes, reset state select to null to force user to choose a new valid state
      self.country.subscribe(function() {
        self.state('');
      });
    },

    orgStateCountryViewModel: function() {
      var self = this;

      self.orgState = ko.observable('');
      self.orgStateDisplay = ko.observable('');
      self.orgCountry = ko.observable('');
      self.orgCountryDisplay = ko.observable('');

      //when country changes, reset state select to null to force user to choose a new valid state
      self.orgCountry.subscribe(function() {
        self.orgState('');
      });
    },

    contactModel: function() {
      var self = this;

      self.orgName = ko.observable('');
      self.positionOpen = ko.observable('');
      self.orgCity = ko.observable('');
      self.orgState = ko.observable('');
      self.fname = ko.observable('');
      self.lname = ko.observable('');
      self.address1 = ko.observable('');
      self.address2 = ko.observable('');
      self.country = ko.observable('');
      self.city = ko.observable('');
      self.state = ko.observable('');
      self.postalCode = ko.observable('');
      self.tel = ko.observable('');
      self.email = ko.observable('');
      self.emailConfirm = ko.observable('');
      self.categoryInterests = ko.observable('');
      self.type = ko.observable('');

      /* Private Company Related Part */
      self.companyName = ko.observable('');
      self.companyAddress1 = ko.observable('');
      self.companyAddress2 = ko.observable('');
      self.orgPostalCode = ko.observable('');
      self.companyTel = ko.observable('');
      self.companyWebsite = ko.observable('');
      self.companyEmail = ko.observable('');
      self.companyEmailConfirm = ko.observable('');
      self.companyPhone = ko.observable('');
      self.telExt = ko.observable('');
      self.fnatntfname = ko.observable('');
      self.fnatntlname = ko.observable('');
      self.companyfnatntEmail = ko.observable('');
      self.companyfnatntPhone = ko.observable('');
    },

    contactViewModel: function() {
      var self = this;
      SageGlobals.contactModel.call(self);

      self.streetAddress = ko.pureComputed(function() {
        if(self.address2() !== '') {
          return self.address1() + ' ' + self.address2();
        }
        else {
          return self.address1();
        }
      });

      self.positionDisplay = ko.pureComputed(function () {
        return self.position() !== '' ? self.position() : '-- Please select your position --';
      });
    },

    leadViewModel: function() {
      var self = this;
      self.orgName = ko.observable('');
      self.orgAddress1 = ko.observable('');
      self.orgAddress2 = ko.observable('');
      self.companySize = ko.observable('');
      self.empCount = ko.observable('');
      self.orgCountry = ko.observable('');
      self.orgCity = ko.observable('');
      self.orgState = ko.observable('');
      self.orgPostalCode = ko.observable('');
      self.orgTel = ko.observable('');
      self.orgWebsite = ko.observable('');
      self.association = ko.observable('');
      self.orgIndustry = ko.observable('');
      self.industrySubCategory = ko.observable('');
      self.nonprofit = ko.observable('');
      self.authorizedPurchase = ko.observable('');
      self.memberLeadSource = ko.observable('');
      self.memberLeadSourceDetail = ko.observable('');
      self.purchasing = ko.observable('');
      self.fname = ko.observable('');
      self.lname = ko.observable('');
      self.email = ko.observable('');
      self.emailConfirm = ko.observable('');
      self.tel = ko.observable('');
      self.telExt = ko.observable('');
      self.position = ko.observable('');
      self.categoryInterests = ko.observable('');
      self.orgIndustryDisplay = ko.observable('');
      self.orgSubIndustryDisplay = ko.observable('');
      self.nonProfitDisplay = ko.observable('');
      self.authorizedPurchaseDisplay = ko.observable('');
      self.positionDisplay = ko.observable('');

      self.categoryInterestsDisplay = ko.pureComputed(function () {
        return self.categoryInterests() !== '' ? self.categoryInterests() : '-- Please select all that apply --';
      });
      self.companySizeDisplay = ko.pureComputed(function () {
        return self.companySize() !== '' ? self.companySize() : '--Select organization size--';
      });
      self.heardAboutDisplay = ko.pureComputed(function () {
        return self.memberLeadSource() !== '' ? self.memberLeadSource() : '--Select --';
      });
      self.authorizedPurchaseDisplay = ko.pureComputed(function () {
        return self.authorizedPurchase() !== '' ? self.authorizedPurchase() : '--Select --';
      });
      self.orgStreetAddress = ko.pureComputed(function() {
        if(self.orgAddress2() !== '') {
          return self.orgAddress1() + ' ' + self.orgAddress2();
        }
        else {
          return self.orgAddress1();
        }
      });
    },

    interestsMultiSelectModel: function() {
      var self = this;
      var DEVCONFIG = window.DEVCONFIG;
      self.interests = ko.observableArray(DEVCONFIG.interestList);

      self.interestActive = ko.observable(false);
      self.activeInterestItem = ko.observable();
      self.currentInterestIndex = ko.observable(null);

      self.interestDisplay = ko.pureComputed(function() {
        var interestCount = self.checkedInterests().length,
            displayString = '-- Please select all that apply --';

        if(interestCount > 0) {
          var interest = self.interests().filter(function(element) {
            return element.key === self.checkedInterests()[0];
          })[0];

          if(interest !== undefined) {
            displayString = interest.value;
          }

          if(interestCount > 1) {
            displayString += ' +';
          }
        }

        return displayString;
      });

      self.checkedInterests = ko.observableArray([]);

      self.clickHandler = function(e) {
        if((!$(e.target).hasClass('multiselect__list') && $(e.target).parents('.multiselect__list').length === 0) || ($(e.target).hasClass('multiselect__inner') || $(e.target).parents('.multiselect__inner').length !== 0)) {
          self.loseInterestActive();
        }
      };

      self.keyPressHandler = function(e) {
        if (e.keyCode === SageGlobals.ESC_KEY_CODE) {
          self.loseInterestActive();
        }
        else if(e.keyCode === SageGlobals.ENTER_KEY_CODE) {
          var key = self.activeInterestItem().key;
          if(self.checkedInterests.indexOf(key) === -1) {
            self.checkedInterests.push(key);
          }
          else {
            self.checkedInterests.remove(key);
          }
        }
      };

      self.setInterestActive = function() {
        if(!self.interestActive()) {
          self.interestActive(true);

          $('.multiselect__container').slideDown(500);

          setTimeout(function() {
            $('html').on('click', self.clickHandler);
            $(document).on('keyup', self.keyPressHandler);
          }, 0);
        }

        return true;
      };

      self.loseInterestActive = function() {
        $('.multiselect__container').slideUp(100);

        $('html').off('click', self.clickHandler);
        $(document).off('keyup', self.keyPressHandler);
        self.interestActive(false);
      };

      self.setActiveInterestItem = function(index, data) {
        self.currentInterestIndex(index());
        self.activeInterestItem(data);
      };

      self.setInterestActiveOnKeyPress = function(data, e) {
        //show multiselect if up/down arrow key pressed to mimic <select>
        if(e.keyCode === SageGlobals.UP_ARROW_KEY_CODE || e.keyCode === SageGlobals.DOWN_ARROW_KEY_CODE) {
          if(self.interestActive()) {
            if(self.currentInterestIndex() === null) {
              self.currentInterestIndex(0);
            }
            else {
              if(e.keyCode === SageGlobals.DOWN_ARROW_KEY_CODE) {
                self.currentInterestIndex(self.currentInterestIndex() === self.interests().length - 1 ? 0 : self.currentInterestIndex() + 1);
              }
              else {
                self.currentInterestIndex(self.currentInterestIndex() === 0 ? self.interests().length - 1 : self.currentInterestIndex() - 1);
              }
            }
            self.activeInterestItem(self.interests()[self.currentInterestIndex()]);
          }

          self.setInterestActive();
        }

        else if(e.keyCode === SageGlobals.TAB_KEY_CODE)  {
          if(!self.interestActive()) {
            return true;
          }
        }
      };
    },

    modalViewModel: function() {
      var self = this;
      self.modalActive = ko.observable(false);

      self.openModal = function() {
        self.modalActive(true);
        $('._modal-container').show();
        document.querySelector('body').classList.add('modal-open');
      };

      self.closeModal = function() {
        self.modalActive(false);
        document.querySelector('body').classList.remove('modal-open');
      };

      self.checkOffClick = function(data, e) {
        if($(e.target).data('modal')) {
          self.closeModal();
        }
        else {
          return true;
        }
      };
    },
    getCookieValue: function (cname){
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    registrationViewModel: function() {
      var self = this;
      SageGlobals.formViewModel.call(self);

      self.data = {};
      self.repData = {};
      self.memberAssocEndPoint = 'MemberAssociation';
      self.redirectUrl = '/account-pending';
      self.objectType = 'lead';

      //stub method that is meant to be overridden to allow for additional properties to be added to the object
      self.getRegistrationFlowData = function(data) {
        return data;
      };

      self.getRepresantativeData = function (data) {
        return data;
      };


      self.register = function() {
        if(self.preSubmit()) {
          //attempt to create SFDC object. (Contact/Lead).
          //Lead will reject if email in use
          //Contact will reject if email in use.
          self.data = self.getRegistrationFlowData();
          callSalesforceApi("/services/apexrest/CreateLeadAndRep", "POST", self.data)
              .then(function(result) {
                if(result.success === true) {
                  //if association selected - create MemberAssociation object and attach to Contact/Lead
                  if(typeof self.userSelectedAssociation !== 'undefined' && self.userSelectedAssociation !== '') {
                    var memberAssociation = {
                      association: self.userSelectedAssociation,
                      isMember: true,
                      lead: result.id,
                      primaryAssociation: true
                    };

                    //memberAssociation[self.objectType] = result.id;
                    var memberAssocProm = _Boomi.sendRequest('POST', 'MemberAssociation', memberAssociation);
                    memberAssocProm.then(function (result) {
                      if(result.success !== 'true') {
                        SageGlobals.log({
                          errorSeverity: 'WARNING',
                          error: result.status.errors,
                          payload: result.payload,
                          description: 'Failure in ' + self.endPoint + ' - ' + self.memberAssocEndPoint + '.Create'
                        });
                        window.location.href = self.redirectUrl;
                      }
                      else {
                        window.location.href = self.redirectUrl;
                      }
                    }).catch(function(response) {
                      //if there is an error adding the association log it, but let the process continue
                      SageGlobals.log({
                        errorSeverity: 'WARNING',
                        error: response,
                        payload: memberAssociation,
                        description: 'Exception thrown during ' + self.endPoint + ' - ' + self.memberAssocEndPoint + '.Create'
                      });
                      window.location.href = self.redirectUrl;
                    });
                  }
                  else {
                    if (self.data.contactType === 'Extended Primary User') {
                      self.repData = self.getRepresantativeData(self.repData,result);
                      var promForRepresentative = _Boomi.sendRequest('POST', self.endPointForRepresentative, self.repData);
                      promForRepresentative.then(function (resultforReps) {
                        if (resultforReps.success === 'true') {
                          window.location.href = self.redirectUrl;
                        }
                      });
                    }
                    else {
                      var date = new Date(),
                          expires = 'expires=';
                      var minutes = 30;
                      date.setTime(date.getTime() + (minutes * 60 * 1000));
                      expires += date.toGMTString();
                      document.cookie =  'details=' + JSON.stringify({fname: self.data.firstName, lname: self.data.lastName,email: self.data.email, phone: self.data.orgTel}) + '; ' + expires + '; path=/';
                      window.location.href = self.redirectUrl;
                    }
                    document.cookie = 'gclid_cookie=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                    document.cookie = 'utm_campaign_cookie=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                    document.cookie = 'utm_medium_cookie=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                    document.cookie = 'utm_source_cookie=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                  }
                  //Function to fetch Lead ID for processing of Interest Reps after form submission
                  self.processInterestReps(result.id);
                }
                else {
                  //200 status = email already in use, any other error means exception in Boomi/SFDC
                  if(result.statusCode === '200' || result.error.includes('Duplicate Contact')) {
                    // failed to create SF contact. But no exception thrown.
                var msg = 'This email already exists in our database. Please <a data-gat="click" data-gatcategory="Registration" data-gatlabel="Email Exists" data-gataction="Toggle Login" href="/join-now/?login=true">login</a>, <a data-gat="click" data-gatcategory="Registration" data-gatlabel="Email Exists" data-gataction="Toggle Reset Password" href="/join-now/?login=true&state=reset">reset your password</a>, or call customer service at <a href="tel:+18773298847" title="Phone Number" >877.329.8847</a> for assistance.';
                    self.setMessage('error', self.errorClass, msg);
                  }
                  else {
                    //failed to create SF contact - delete Auth0 account to ensure atomic operation
                    SageGlobals.log({
                      errorSeverity: 'WARNING',
                      error: result.status.errors || result.status,
                      payload: result.payload,
                      description: 'Error creating ' + self.endPoint + '.create'
                    });
                    self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
                  }
                }
              })
              .catch(function(response) {
                var errorMessage = '';
                jQuery("#loader").hide();
                if (response.responseText) {
                  try {
                    var errorObj = JSON.parse(response.responseText);
                    errorMessage = errorObj.error;

                    // Check for specific duplicate email error
                    if (errorMessage && errorMessage.includes('Duplicate Contact')) {
                      var msg = 'This email already exists in our database. Please <a data-gat="click" data-gatcategory="Registration" data-gatlabel="Email Exists" data-gataction="Toggle Login" href="/?login=true">login</a>, <a data-gat="click" data-gatcategory="Registration" data-gatlabel="Email Exists" data-gataction="Toggle Reset Password" href="/?login=true&state=reset">reset your password</a>, or call customer service at 877.329.8847 for assistance.';
                      self.setMessage('error', self.errorClass, msg);
                    } else {
                      self.setMessage('error', self.errorClass, 'Something went wrong during registration. Please try again later.');
                    }
                  } catch (e) {
                    errorMessage = 'Failed to parse error response.';
                    self.setMessage('error', self.errorClass, errorMessage);
                  }
                }
                //exception thrown during create request
                SageGlobals.log({
                  errorSeverity: 'WARNING',
                  error: response,
                  payload: self.data,
                  description: 'Exception creating ' + self.endPoint + '.create'
                });
                // self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
              });
        }
      };
    },

    common: function() {
      //setup form classes string
      var classes = Object.getOwnPropertyNames(this.formStateClasses);
      this.formClasses = classes.reduce(function(a, b) {
        return this.formStateClasses[a] + ' ' + this.formStateClasses[b];
      }.bind(this));
      /* for pardot dynamic script code start*/
      if(jQuery('#has_script').length !== 0){ jQuery("p").first().appendTo('head').contents().unwrap(); }
      /* for pardot dynamic script code end*/
    },

    /*
     *  getQueryParameters.js
     *  Copyright (c) 2014 Nicholas Ortenzio
     *  The MIT License (MIT)
     *
     */
    getQueryParameters: function(str) {
      return decodeURIComponent((str || document.location.search)).replace(/(^\?)/, '').split("&").map(function (n) {
        return n = n.split("="), this[n[0]] = n[1], this;
      }.bind({}))[0];
    }
  };

  var Sage = {
    // All pages
    'common': {

      // JavaScript to be fired on all pages
      init: function() {
        //set initial set of logged in. Key off log out button in header
        var userState = new SageGlobals.UserLoggedInViewModel($('#logout').length !== 0);
        var oldFlexBoxSupport = Modernizr.prefixedCSSValue('display', 'flex') === '-webkit-flex';

        SageGlobals.common();
        if ( ! Modernizr.objectfit ) {
          $('.hero').each(function () {
            var $container = $(this),
                imgUrl = $container.find('.hero__image').prop('src');
            if (imgUrl) {
              $container
                  .css('backgroundImage', 'url(' + imgUrl + ')')
                  .addClass('hero--no-object-fit ');
            }
          });
        }

        if(oldFlexBoxSupport) {
          $('html').addClass('old-flex');
        }

        //polyfill html5 form functionality such as validation etc
        webshim.setOptions('loadStyles', false);
        webshims.polyfill('forms');

        //init header nav
        //calc height of nav to push submenu to be flush with bottom of header
        var $primaryNav = $('#primary-nav'),
            $banner = $('#banner'),
            paddingDifference = parseInt($banner.css('padding-top'), 10) - parseInt($banner.css('padding-bottom'), 10);

        $primaryNav.find('.sub-menu').css('padding-top', ($('#banner').outerHeight() - paddingDifference - $primaryNav.outerHeight()) / 2);

        //make header fixed
        this.initKo();
        this.setupBanner();
        this.initSessionCheck(userState);
      },

      initKo: function() {
        ko.bindingHandlers.updateStateSelectDisplay = {
          init: function(element, valueAccessor, allBindings, bindingContext) {
            var value = valueAccessor(),
                valueUnwrapped = ko.unwrap(value);

            bindingContext.stateDisplay($(element).find(':selected').text());
          },
          update: function(element, valueAccessor, allBindings, bindingContext) {
            var value = valueAccessor(),
                valueUnwrapped = ko.unwrap(value);

            bindingContext.stateDisplay($(element).find(':selected').text());
          }
        };

        ko.bindingHandlers.updateCountrySelectDisplay = {
          init: function(element, valueAccessor, allBindings, bindingContext) {
            var value = valueAccessor(),
                valueUnwrapped = ko.unwrap(value);

            bindingContext.countryDisplay($(element).find(':selected').text());
          },
          update: function(element, valueAccessor, allBindings, bindingContext) {
            var value = valueAccessor(),
                valueUnwrapped = ko.unwrap(value);

            bindingContext.countryDisplay($(element).find(':selected').text());
          }
        };

        ko.bindingHandlers.updateOrgStateSelectDisplay = {
          init: function(element, valueAccessor, allBindings, bindingContext) {
            var value = valueAccessor(),
                valueUnwrapped = ko.unwrap(value);

            bindingContext.orgStateDisplay($(element).find(':selected').text());
          },
          update: function(element, valueAccessor, allBindings, bindingContext) {
            var value = valueAccessor(),
                valueUnwrapped = ko.unwrap(value);

            bindingContext.orgStateDisplay($(element).find(':selected').text());
          }
        };

        ko.bindingHandlers.updateOrgCountrySelectDisplay = {
          init: function(element, valueAccessor, allBindings, bindingContext) {
            var value = valueAccessor(),
                valueUnwrapped = ko.unwrap(value);

            bindingContext.orgCountryDisplay($(element).find(':selected').text());
          },
          update: function(element, valueAccessor, allBindings, bindingContext) {
            var value = valueAccessor(),
                valueUnwrapped = ko.unwrap(value);

            bindingContext.orgCountryDisplay($(element).find(':selected').text());
          }
        };

        ko.bindingHandlers.updateAccountSelectDisplay = {
          init: function(element, valueAccessor, allBindings, bindingContext) {
            var value = valueAccessor(),
                valueUnwrapped = ko.unwrap(value);

            bindingContext.accountDisplay($(element).find(':selected').text());
          },
          update: function(element, valueAccessor, allBindings, bindingContext) {
            var value = valueAccessor(),
                valueUnwrapped = ko.unwrap(value);

            bindingContext.accountDisplay($(element).find(':selected').text());
          }
        };


        ko.bindingHandlers.updateIndustrySelectDisplay = {
          init: function(element, valueAccessor, allBindings, bindingContext) {
            var value = valueAccessor(),
                valueUnwrapped = ko.unwrap(value);

            bindingContext.orgIndustryDisplay($(element).find(':selected').text());
          },
          update: function(element, valueAccessor, allBindings, bindingContext) {
            var value = valueAccessor(),
                valueUnwrapped = ko.unwrap(value);

            bindingContext.orgIndustryDisplay($(element).find(':selected').text());
          }
        };
        ko.bindingHandlers.updateSubIndustrySelectDisplay = {
          init: function(element, valueAccessor, allBindings, bindingContext) {
            var value = valueAccessor(),
                valueUnwrapped = ko.unwrap(value);

            bindingContext.orgSubIndustryDisplay($(element).find(':selected').text());
          },
          update: function(element, valueAccessor, allBindings, bindingContext) {
            var value = valueAccessor(),
                valueUnwrapped = ko.unwrap(value);

            bindingContext.orgSubIndustryDisplay($(element).find(':selected').text());
          }
        };

        ko.bindingHandlers.updatePositionSelectDisplay = {
          init: function(element, valueAccessor, allBindings, bindingContext) {
            var value = valueAccessor(),
                valueUnwrapped = ko.unwrap(value);

            bindingContext.positionDisplay($(element).find(':selected').text());
          },
          update: function(element, valueAccessor, allBindings, bindingContext) {
            var value = valueAccessor(),
                valueUnwrapped = ko.unwrap(value);

            bindingContext.positionDisplay($(element).find(':selected').text());
          }
        };
        ko.bindingHandlers.updateNonprofitSelectDisplay = {
          init: function(element, valueAccessor, allBindings, bindingContext) {
            var value = valueAccessor(),
                valueUnwrapped = ko.unwrap(value);

            bindingContext.nonProfitDisplay($(element).find(':selected').text());
          },
          update: function(element, valueAccessor, allBindings, bindingContext) {
            var value = valueAccessor(),
                valueUnwrapped = ko.unwrap(value);

            bindingContext.nonProfitDisplay($(element).find(':selected').text());
          }
        };
        ko.bindingHandlers.updateCategoryInterestsSelectDisplay = {
          init: function(element, valueAccessor, allBindings, bindingContext) {
            var value = valueAccessor(),
                valueUnwrapped = ko.unwrap(value);

            bindingContext.accountDisplay($(element).find(':selected').text());
          },
          update: function(element, valueAccessor, allBindings, bindingContext) {
            var value = valueAccessor(),
                valueUnwrapped = ko.unwrap(value);

            bindingContext.accountDisplay($(element).find(':selected').text());
          }
        };

        ko.bindingHandlers.updateAssociationSelectDisplay = {
          update: function(element, valueAccessor, allBindings, bindingContext) {
            var value = valueAccessor(),
                valueUnwrapped = ko.unwrap(value),
                state = bindingContext.orgState();

            // only fire off request if we have valid parameters
            if(bindingContext.validStateSelection()) {
              bindingContext.associationsLoaded(false);
              //TODO: figure out some kind of caching option here to avoid timeouts
              //cache ALL associations for 24 hours and just request subset here?
              var promAssoc = _Boomi.sendRequest('GET', 'Account/associationlist', '', {'X-boomi-state': state});

              promAssoc.then(function(result) {
                if(result.success === 'true') {
                  if(result.accountList) {
                    //empty association array before populating with new results
                    bindingContext.availableAssociations([]);
                    result.accountList.forEach(function(item) {
                      bindingContext.availableAssociations.push(new bindingContext.Association(item));
                    });
                  }
                  else {
                    //log failure to find associations -- should only happen for Other industry.
                    SageGlobals.log({
                      errorSeverity: 'NOTICE',
                      error: 'Empty query result',
                      payload: 'State: ' + state,
                      description: 'NO associations returned from  Account/associationlist.Get'
                    });
                  }
                }
                else {
                  bindingContext.availableAssociations([]);
                  SageGlobals.log({
                    errorSeverity: 'WARNING',
                    error: result.status.errors,
                    payload: 'State: ' + state,
                    description: 'Error returned from Account/associationlist.Get'
                  });
                }
                bindingContext.associationsLoaded(true);
              })
                  .catch(function(response) {
                    SageGlobals.log({
                      errorSeverity: 'WARNING',
                      error: response,
                      payload: 'State: ' + state,
                      description: 'Exception thrown during Account/associationlist.Get'
                    });
                  });
            }
            else {
              bindingContext.availableAssociations([]);
            }
          }
        };

        ko.bindingHandlers.valueWithInitialize = {
          init: function(element, valueAccessor, allBindingsAccessor) {
            var value = valueAccessor();
            if (ko.isObservable(value)) {
              value(element.value);
            }
            ko.bindingHandlers.value.init(element, valueAccessor, allBindingsAccessor);
          },
          update: function(element, valueAccessor) {
            ko.bindingHandlers.value.update(element, valueAccessor);
          }
        };
      },

      initSessionCheck: function(userState) {
        function redirectUser(isLoggedIn) {
          //if user is logged out send them to inactive page else just reload the current page
          if(!isLoggedIn) {
            var redirect = SageGlobals.invalidRedirects.indexOf(window.location.pathname) !== -1 ? '/' : window.location.pathname;
            window.location.href = '/logged-out-inactive?redirection=' + redirect;
          }
          else {
            window.location.reload(false);
          }
        }

        //only check 1x/minute for logged in state change
        var checkUserSession = SageGlobals.debounce(function() {
          $.ajax({
            method: 'POST',
            url: '/lib/check-user-session.php',
            data: {
              'nonce': $('#user-session-nonce').val(),
              'loggedInState': userState.isLoggedIn()
            }
          })
              .done(function (data) {
                var result = JSON.parse(data);
                if(result.success === 'true') {
                  if(result.stateChange) {
                    redirectUser(result.loggedIn);
                  }
                }
                else {
                  //nonce invalid - force refresh
                  if(result.stateChange) {
                    redirectUser(result.loggedIn);
                  }
                  else {
                    window.location.reload(false);
                  }
                }
              })
              .fail(function (data) {
                SageGlobals.log({
                  errorSeverity: 'WARNING',
                  error: 'No Data found',
                  description: 'Error returned from check user session'
                });
              });
        }, 60000, true);

        //wait 15 minutes before testing for session change on focus. Session timeout is 24 minutes so we should cover it easily
        setTimeout(function() {
          $(window).on('focus', checkUserSession);
        }, 900000);
      },

      setupBanner: function() {
        var domain = CONFIG.AUTH0_DOMAIN,
            clientID = CONFIG.AUTH0_CLIENT_ID,
            redirectionUrl = CONFIG.AUTH0_REDIRECTION_URL;

        var BannerViewModal = function() {
          var self = this,
              queryParams = SageGlobals.getQueryParameters();

          SageGlobals.modalViewModel.call(self);
          SageGlobals.formViewModel.call(self);

          var login = queryParams.login ? queryParams.login : 'false';
          var validStates = ['login', 'reset'];
          var state = queryParams.state && validStates.indexOf(queryParams.state) !== -1 ? queryParams.state : 'login';

          if(login === 'true') {
            self.modalActive(true);
          }
          self.state = ko.observable(state);

          self.setState = function(val) {
            self.state(val);
            self.resetMessages();
          };
        };

        var LoginFormViewModel = function(bannerViewModal) {
          var self = this;
          SageGlobals.formViewModel.call(self);
          self.email = ko.observable('');
          self.password = ko.observable('');
          self.submit('Login');

          self.bannerViewModel = bannerViewModal;

          self.validate = ko.pureComputed(function () {
            return self.validateEmail(self.email()) &&
                self.password() !== '';
          });

          self.setState = function(val) {
            self.bannerViewModel.setState(val);
          };

          self.handleLogin = function() {
            if(self.preSubmit()) {
              var connection = CONFIG.connection.DB,
                  queryParams = SageGlobals.getQueryParameters(),
                  redirect = queryParams.redirection ? SageGlobals.formatRedirectUrl(decodeURIComponent(queryParams.redirection)) : window.location.pathname;

              //if redirect location is a page that doesn't make sense e.g. /migrate send user to home instead
              if(SageGlobals.invalidRedirects.indexOf(redirect) !== -1) {
                redirect = '/';
              }
                            
              // Track auth timing for metrics
              var authStartTime = new Date().getTime();

              /* jshint ignore:start */
              var WebAuth = new auth0.WebAuth({
                domain:         domain,
                responseType:   'token id_token',
                clientID:       clientID,
                redirectUri:    redirectionUrl + '?connection=' + connection + '&origin=' + redirect  + '&redirectStart=' + authStartTime
                // redirectUri:    redirectionUrl + '?connection=' + connection + '&origin=' + redirect
              });

              WebAuth.login({
                realm: connection,
                username: self.email(),
                email: self.email(),
                password: self.password(),
                responseMode: 'form_post'
              }, function(response) {
                //override error message if invalid password to give additional guidance

                if(response.code === 'access_denied') {
                  //query for 'imported' user. If found, send change email address email and update message
                  var queryParams = {
                    fields: 'email,app_metadata',
                    searchValues: self.email()
                  };
                  var errorMessage = 'Your email and/or password is incorrect. Confirm your email above, or click the Forgot Password link to reset your password.<br><br>If you need assistance, please contact us at <a href="mailto:customerservice@nppgov.com">customerservice@nppgov.com</a> or <a href="tel:8773298847">877.329.8847</a>.';

                  _Auth0.query(queryParams).then(function (result) {
                    if(result.success) {
                      var user = result.response[0];

                      //user will be undefined is the email address does not exist in Auth0
                      if (user !== undefined && user.app_metadata && user.app_metadata.hasOwnProperty('imported') && user.app_metadata.imported) {
                        var resetPassword = new SageGlobals.resetPasswordViewModal(user.email);
                        resetPassword.resetPassword();
                        self.setMessage('success', self.successClass, 'We\'ve updated our systems. We are sending you an email with password reset instructions.');
                      }
                      else {
                        //regular password failure or email doesn't exist
                        self.setMessage('error', self.errorClass, errorMessage);
                      }
                    }
                    else {
                      self.setMessage('error', self.errorClass, errorMessage);
                    }

                  }).catch(function (response) {
                    SageGlobals.log({
                      errorSeverity: 'WARNING',
                      error: response,
                      payload: self.email(),
                      description: 'Exception querying Auth0 during NPP login imported user check'
                    });
                    self.setMessage('error', self.errorClass, errorMessage);
                  });
                }
                else {
                  self.setMessage('error', self.errorClass, response.message);
                }
              });
              /* jshint ignore:end */
            }
          };
        };
        $(document).ready(function() {
          $(document).on('click', '.cancel-modal', function(e) {
            e.preventDefault();

            // Hide the modal
            $(this).closest('._modal-container').hide();

            // Remove the 'modal-open' class from the body
            document.querySelector('body').classList.remove('modal-open');

            // Clear the form fields
            var form = $(this).closest('form');
            if (form.length) {
              form[0].reset();
              form.find('input:text, input:password').val('');
              form.find('.form__list .list__item').removeClass('is_error');
              form.find('.form__list').empty(); // This removes all list items
              var passwordField = form.find('.password-field-wrapper input[type="password"], .password-field-wrapper input[type="text"]');
              var showIcon = form.find('.password-field-wrapper .pass-show');
              var hideIcon = form.find('.password-field-wrapper .pass-hide');

              if (passwordField.length) {
                passwordField.attr('type', 'password');
              }

              if (showIcon.length && hideIcon.length) {
                showIcon.show();
                hideIcon.hide();
              }
            }
          });

        });

        var ResetPasswordModalViewModel = function(bannerViewModal) {
          var self = this;
          SageGlobals.resetPasswordViewModal.call(self);

          self.bannerViewModel = bannerViewModal;

          self.setState = function(val) {
            self.bannerViewModel.setState(val);
          };
        };

        ko.bindingHandlers.stopBinding = {
          init: function () {
            return {controlsDescendantBindings: true};
          }
        };
        ko.virtualElements.allowedBindings.stopBindings = true;

        var bannerViewModal = new BannerViewModal();
        // //check for existence of banner before binding KO because some pages don't have the banner
        if(document.getElementById('banner')) {
          ko.applyBindings(bannerViewModal, document.getElementById('banner'));
        }

        if(document.getElementById('login-form')) {
          ko.applyBindings(new LoginFormViewModel(bannerViewModal), document.getElementById('login-form'));
          // ko.applyBindings(new LoginFormViewModel(), document.getElementById('login-form'));
        }

        if(document.getElementById('reset-form')) {
          ko.applyBindings(new ResetPasswordModalViewModel(bannerViewModal), document.getElementById('reset-form'));
        }
      },

      finalize: function() {
      }
    },

    // Home
    'home': {
      init: function() {
        var queryParams = SageGlobals.getQueryParameters();
        var contactUpdate = queryParams.hasOwnProperty('contactUpdate');
        if (contactUpdate) {
          var date1 = new Date();
          date1.setTime(date1.getTime()+(2147483647 * 1000));
          var expires1 = "; expires="+date1.toGMTString();
          document.cookie = "contactUpdateGov=Submitted"+expires1+"; path=/";
          jQuery('#myModalContact').modal('show');
          jQuery('#myModalContact').attr('style', 'display: block !important');
          jQuery('#offer_redemption_main_contact').css('display','none');
          jQuery('#offer_redemption_thanks_contact').css('display','block');
          window.history.pushState('page2', 'Title', '/');
        }
        jQuery("#myModalContact #modal-btn-si").off('click').on("click", function(){
          jQuery('#myModalContact').modal('hide');
          var date = new Date();
          date.setTime(date.getTime()+(2147483647 * 1000));
          var expires = "; expires="+date.toGMTString();
          document.cookie = "contactUpdateGov=Submitted"+expires+"; path=/";
        });
        jQuery("#myModalContact").on('hidden.bs.modal', function () {
          jQuery('#myModalContact').modal('hide');
          var date = new Date();
          date.setTime(date.getTime()+(2147483647 * 1000));
          var expires = "; expires="+date.toGMTString();
          document.cookie = "contactUpdateGov=Submitted"+expires+"; path=/";
        });

        $(function(){
//        $('.industry').bxSlider({
//           auto: false,
//           //touchEnabled:false,
//           touchEnabled : (navigator.maxTouchPoints > 0),
//          autoControls: false,
//          speed: 500,
//          //infiniteLoop: false,
//          slideSelector: 'div.item',
//          minSlides: 6,
//          maxSlides: 6,
//          moveSlides: 1,
//          slideWidth: 500,
//          pager:false,
//          controls:false,
//
//
//      });
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },

    //Offer Detail
    'single_contract': {
      init: function() {
          var queryParams = SageGlobals.getQueryParameters();
          var tab = queryParams.tab;
          if (tab === 'document') {
              $('.detail-tab').removeClass('active');
              $('.contact-tab').removeClass('active');
              $('.detail-tab-content').removeClass('active');
              $('.contact-tab-content').removeClass('active');
              $('.document-tab').addClass('active');
              $('.document-tab-content').addClass('active');
          }
          if (tab === 'contact') {
              $('.detail-tab').removeClass('active');
              $('.document-tab').removeClass('active');
              $('.detail-tab-content').removeClass('active');
              $('.document-tab-content').removeClass('active');
              $('.contact-tab').addClass('active');
              $('.contact-tab-content').addClass('active');
          }
        //AJAX submission of redemption link
        var RedemptionLinkViewModel = function($form) {
          var self = this;

          SageGlobals.formViewModel.call(self);

          self.handleSubmit = function() {
            var data = $form.serialize(),
                action = $form.attr('action'),
                method = $form.attr('method'),
                url = $(this).attr('href');

            _Lib.sendRequest('POST', 'redeem.php', data);
            return true;
          };
        };

        $('[data-redemption]').each(function() {
          var $form = $(this);
          ko.applyBindings(new RedemptionLinkViewModel($form), $form.get(0));
        });
        var ActivityViewModel = function($form) {
          var self = this;

          SageGlobals.formViewModel.call(self);

          self.handleActivitySubmit = function() {
            var data = $form.serialize(),
                action = $form.attr('action'),
                method = $form.attr('method'),
                url = $(this).attr('href');

            _Lib.sendRequest('POST', 'offer-activity.php', data);
            return true;
          };
        };

        $('[data-view]').each(function() {
          var $form = $(this);
          ko.applyBindings(new ActivityViewModel($form), $form.get(0));
        });
      }
    },
    //Single Landin page
    'single_landing_page': {
      init: function () {
        var queryParams = SageGlobals.getQueryParameters();
        var formAssemblySubmitted = queryParams.hasOwnProperty('tfa_next');
        var response = queryParams.tfa_next ? queryParams.tfa_next : '';
        console.log(response);
        if (formAssemblySubmitted  ) {
          jQuery('#myModal').modal('show');
          jQuery('#offer_redemption_thanks').css('display','block');
          window.history.pushState('page2', 'Title', window.location.pathname);
        }
      }
    },

    //Single RM Landin page
    'single_rm_landing_page': {
      init: function () {
        var queryParams = SageGlobals.getQueryParameters();
        var formAssemblySubmitted = queryParams.hasOwnProperty('tfa_next');
        var response = queryParams.tfa_next ? queryParams.tfa_next : '';
        console.log(response);
        if (formAssemblySubmitted && response==='/responses/last_success' ) {
          jQuery('#myModal').modal('show');
          jQuery('.success_msg').remove();
          jQuery('.show_form').show();
          jQuery('#offer_redemption_thanks').css('display','block');
          window.history.pushState('page2', 'Title', window.location.pathname);
        } else if (formAssemblySubmitted && response!=='/responses/last_success' ) {
          jQuery('.success_msg').show();
          jQuery('.show_form').hide();
        }
      }
    },

    //Referral Function Page
    //'page_id_3422': { //for dev
    'page_id_7935': { //for production
      init: function () {
        jQuery('#SelectReferrals').change(function () {
          //show form according selection
          if (jQuery(this).val() === '5008891') {
            window.location.href = "/referrals/?ref=company";
          }
          if (jQuery(this).val() === '5008892') {
            window.location.href = "/referrals/?ref=membership";
          }
        });

        var queryParams = SageGlobals.getQueryParameters();
        var FormKey = queryParams.ref;
        if (FormKey === 'membership') {
          jQuery('#SelectReferrals option[value="5008892"]').prop('selected', true);
        }

        if (FormKey === 'company') {
          jQuery('#SelectReferrals option[value="5008891"]').prop('selected', true);
        }
        var formAssemblySubmitted = queryParams.hasOwnProperty('tfa_next');
        var response = queryParams.tfa_next ? queryParams.tfa_next : '';
        console.log(response);
        if (formAssemblySubmitted && response==='/responses/last_success?jsid' ) {
          jQuery('#myModal').modal('show');
          //jQuery('.show_form').show();
          jQuery('#offer_redemption_thanks').css('display','block');
          window.history.pushState('page2', 'Title', window.location.pathname);
          jQuery('#SelectReferrals option[value="default"]').prop('selected', true);
        } else if (formAssemblySubmitted && response!=='/responses/last_success?jsid' ) {
          jQuery('.success_msg').show();
          //jQuery('.show_form').hide();
        }
      }
    },

    //Become a Vendor Page
    'page_id_1175': {
      init: function () {

        var queryParams = SageGlobals.getQueryParameters();
        var formAssemblySubmitted = queryParams.hasOwnProperty('tfa_next');
        var response = queryParams.tfa_next ? queryParams.tfa_next : '';
        console.log(response);
        if (formAssemblySubmitted) {
          jQuery('#myModal').modal('show');
          jQuery('.show_form').show();
          jQuery('#offer_redemption_thanks').css('display','block');
          window.history.pushState('page2', 'Title', window.location.pathname);
        } else {
          jQuery('.success_msg').show();
          jQuery('.show_form').hide();
        }
      }
    },

    //Registration
    'page_id_332': {
      init: function() {
        //test if we need to show a registration flow by default
        var queryParams = SageGlobals.getQueryParameters();
        var flow = queryParams.hasOwnProperty('flow') && ['Government', 'Nonprofit', 'Retiree','Private'].indexOf(queryParams.flow) !== -1 ? queryParams.flow : '';
        setTimeout(function () {
          jQuery('#govButton').trigger('click');
        }, 1000);
        var ViewModel = function (flow) {
          var self = this;
          SageGlobals.modalViewModel.call(self);

          self.helpActive = ko.observable(false);
          self.flow = ko.observable(flow);

          self.setFlow = function(flow) {
            self.flow(flow);
          };
        };
        // Functionality to toggle display and required attributes based on the selection of working partners.
        var partnersRadio = document.querySelectorAll('input[name="workingpartner"]');
        var interestFields = document.querySelector('.interest-fields');
        var partnerCompany = document.querySelector('.tax_number1');
        var allFields = document.querySelectorAll('.interest-fields input');
        function toggleFields() {
          if (partnersRadio[0].checked) {
            interestFields.style.display = 'block';
            partnerCompany.style.display = 'block';
            allFields.forEach(function(field) {
              field.setAttribute('required', 'required');
            });
          } else {
            interestFields.style.display = 'none';
            partnerCompany.style.display = 'none';
            allFields.forEach(function(field) {
              field.removeAttribute('required');
            });
          }
        }

        toggleFields();

        partnersRadio.forEach(function(radio) {
          radio.addEventListener('change', toggleFields);
        });

        var GovViewModel = function () {

          var self = this;
          SageGlobals.registrationViewModel.call(self);
          SageGlobals.leadViewModel.call(self);
          SageGlobals.orgStateCountryViewModel.call(self);
          SageGlobals.interestsMultiSelectModel.call(self);
          self.flow = ko.observable('Government');
          self.orgFederalTaxId = ko.observable();
          self.fdid = ko.observable();
          self.studentCount = ko.observable();
          self.orgName = ko.observable('');
          var gclid_cookie_val=SageGlobals.getCookieValue('gclid_cookie');
          var gclid=queryParams.gclid || gclid_cookie_val ||'';

          var utm_campaign_cookie_val=SageGlobals.getCookieValue('utm_campaign_cookie');
          var utm_campaign=queryParams.utm_campaign || utm_campaign_cookie_val ||'';

          var utm_medium_cookie_val=SageGlobals.getCookieValue('utm_medium_cookie');
          var utm_medium=queryParams.utm_medium || utm_medium_cookie_val ||'';

          var utm_source_cookie_val=SageGlobals.getCookieValue('utm_source_cookie');
          var utm_source=queryParams.utm_source || utm_source_cookie_val ||'';

          //self.purchasing('Yes');
          self.$referrerAssociation = $('#referrer-association');
          self.$referrerAssociationName = $('#referrer-association-name');
          self.memberAssocEndPoint = 'Member_Association__c';



          self.computedAssociation = ko.pureComputed(function() {
            return self.$referrerAssociation.length ? self.$referrerAssociation.val() : '';
          });

          self.computedAssociationName = ko.pureComputed(function() {
            return self.$referrerAssociationName.length ? self.$referrerAssociationName.val() : '';
          });
          self.partners = ko.observable('');
          self.workingpartner = ko.observable('');
          self.rep_Name = ko.observable('');
          self.rep_email = ko.observable('');
          self.rep_tel = ko.observable('');
          self.validateNoPartner = function() {
            return (
                self.validateEmail(self.email()) &&
                self.orgName() !== 'a' &&
                self.orgAddress1() !== '' &&
                self.orgCountry() !== '' &&
                self.orgCity() !== '' &&
                self.orgState() !== '' &&
                self.validatePostalCode(self.orgPostalCode(), self.orgCountry()) &&
                self.validateTel(self.orgTel()) &&
                self.validateUrlOpt(self.orgWebsite()) &&
                self.orgIndustry() !== '' &&
                self.authorizedPurchase() !== '' &&
                self.memberLeadSource() !== '' &&
                // self.purchasing() !== '' &&
                self.fname() !== '' &&
                self.lname() !== '' &&
                self.validateTel(self.orgTel()) &&
                self.position() !== ''
            );
          };
          //Validation of interest Rep fields

          self.validate = function() {
            if (self.workingpartner() === 'No') {
              return self.validateNoPartner();
            } else {
              return (
                  self.validateNoPartner() &&
                  self.partners() !== '' &&
                  self.rep_email() !== '' &&
                  self.rep_tel() !== '' &&
                  self.rep_Name() !== ''
              );
            }
          };

          //additional data
          self.Association = function(association) {
            this.id = association.id;
            this.name = association.name;
          };

          self.availableAssociations = ko.observableArray([]);
          self.selectedAssociation = ko.observable();
          self.showAssociationSelection = ko.pureComputed(function() {
            self.validStateSelection();
          });

          self.validStateSelection = function() {
            return self.orgState() === 'OR';
          };
          self.orgIndustry.subscribe(function() {
            self.industrySubCategory('');
          });
          //dynamic industry/sub industry start
          SageGlobals.dynamicCategoryList.call(self);
          //dynamic industry/sub industry end
          self.associationsLoaded = ko.observable(false);

          self.selectedAssociationDisplay = ko.pureComputed(function() {
            return self.selectedAssociation() ? self.selectedAssociation().name : '--Select Association--';
          });

          self.endPoint = 'Lead';
          self.leadSource = 'Web';
          self.recordType = CONFIG.sfdc.recordType.LEAD;
          self.accountType = 'Government_Education_Public_Safety';
          self.contactType = 'Government';
          self.referrerAssociation = ko.observable('');
          self.$referrerAssociation = $('#referrer-association');
          self.$referrerAssociationName = $('#referrer-association-name');
          self.getRegistrationFlowData = function () {
            var data = {
              lead: {},
              // rep: {},
              isSalesRepCreation: false
            };
            //lead fields
            data.lead.companyName = self.orgName();
            data.lead.street = self.orgStreetAddress();
            data.lead.country = self.orgCountry();
            data.lead.companySize = self.companySize();
            data.lead.nonprofit = jQuery("#nonprofit option:selected").val() === "1";
            data.lead.empCount = (Number(self.empCount()) || 0).toString();
            data.lead.city = self.orgCity();
            data.lead.state = self.orgState();
            data.lead.postalCode = self.orgPostalCode();
            data.lead.accountTel = self.orgTel();
            data.lead.website = self.orgWebsite();
            data.lead.industry = self.orgIndustry();
            data.lead.industrySubCategory = self.industrySubCategory();
            data.lead.authorizedPurchaseOrganization = self.authorizedPurchase();
            data.lead.memberLeadSource = self.memberLeadSource();
            data.lead.memberLeadSourceDetail = self.memberLeadSourceDetail();
            //data.purchasing = self.purchasing();
            data.lead.firstname = self.fname();
            data.lead.lastname = self.lname();
            data.lead.email = self.email();
            data.lead.federalTaxId = self.orgFederalTaxId();
            data.lead.fdid = self.fdid();
            data.lead.studentCount = self.studentCount();
            data.lead.phone = self.tel();
            data.lead.ext = self.telExt();

            data.lead.position = self.position();
            data.lead.gclid = gclid;
            data.lead.utm_source = utm_source;
            data.lead.utm_medium = utm_medium;
            data.lead.utm_campaign = utm_campaign;
            data.lead.categoryInterest = self.checkedInterests().join(';');
            data.lead.recordTypeId = self.recordType;
            data.lead.leadSource = self.leadSource;
            data.lead.accountType = self.accountType;
            data.lead.contactType = self.contactType;
            data.lead.emailDuplicationCheck = self.email() + ' - Employee (Gov)';


            if (self.rep_Name() && self.rep_email() && self.rep_tel() && self.partners()) {
              data.isSalesRepCreation = true;
              data.interestsreps = {
                vendor : self.partners(),
                repName :self.rep_Name(),
                repEmail : self.rep_email(),
                repPhone :self.formatTel(self.rep_tel()),
                categories: ""
              };
            }

            return data;
          };
        };

        //        var NonProfitModel = function() {
        //          var self = this;
        //          GovViewModel.call(self);
        //
        //          self.flow = ko.observable('Nonprofit');
        //          self.accountType = 'Nonprofit';
        //          self.contactType = 'Nonprofit';
        //          self.orgFederalTaxId = ko.observable();
        //
        //          self.referrerAssociation = ko.observable('');
        //                             self.$referrerAssociation = $('#referrer-association');
        //                             self.$referrerAssociationName = $('#referrer-association-name');
        //
        //
        //
        //          self.computedAssociation = ko.pureComputed(function() {
        //                return self.$referrerAssociation.length ? self.$referrerAssociation.val() : '';
        //              });
        //
        //              self.computedAssociationName = ko.pureComputed(function() {
        //                return self.$referrerAssociationName.length ? self.$referrerAssociationName.val() : '';
        //              });
        //
        //          self.getRegistrationFlowData = function(data) {
        //            //lead fields
        //            data.orgName = self.orgName();
        //            data.streetAddress = self.orgStreetAddress();
        //            data.companySize = self.companySize();
        //             data.empCount = self.empCount();
        //
        //            data.country = self.orgCountry();
        //            data.city = self.orgCity();
        //            data.state = self.orgState();
        //            data.postalCode = self.orgPostalCode();
        //            data.orgTel = self.orgTel();
        //            data.website = self.orgWebsite();
        //            data.industry = self.orgIndustry();
        //            data.industrySubCategory = self.industrySubCategory();
        //            data.authorizedPurchaseOrganization = self.authorizedPurchase();
        //            data.memberLeadSource = self.memberLeadSource();
        //            data.memberLeadSourceDetail = self.memberLeadSourceDetail();
        //            data.purchasing = self.purchasing();
        //            data.firstName = self.fname();
        //            data.lastName = self.lname();
        //            data.email = self.email();
        //            data.tel = self.tel();
        //            data.ext = self.telExt();
        //            data.position = self.position();
        //            data.federalTaxId = self.orgFederalTaxId();
        //            data.interest = self.checkedInterests().join(';');
        //            data.recordTypeId = self.recordType;
        //            data.leadSource = self.leadSource;
        //            data.accountType = self.accountType;
        //            data.contactType = self.contactType;
        //
        //            //association data
        //
        //             if(self.computedAssociation() !== '') {
        //                  self.userSelectedAssociation = self.computedAssociation();
        //
        //                                      //if lead is referred from association landing page override lead source and lead source detail
        //                   data.leadSourceDetail = self.computedAssociationName();
        //                }
        //                else {
        //                  self.userSelectedAssociation = self.selectedAssociation() ? self.selectedAssociation().id : '';
        //                }
        //           // self.userSelectedAssociation = self.selectedAssociation() ? self.selectedAssociation().id : '';
        // if(self.$referrerAssociation.length){
        //                         self.userSelectedAssociation=self.$referrerAssociation.val();
        //                        } else {
        //            self.userSelectedAssociation = self.selectedAssociation() ? self.selectedAssociation().id : '';
        //            }
        //            return data;
        //          };
        //        };

        // var PrivateViewModel = function () {
        //   var self = this;
        //   SageGlobals.registrationViewModel.call(self);
        //   SageGlobals.contactViewModel.call(self);
        //   SageGlobals.stateCountryViewModel.call(self);
        //   SageGlobals.orgStateCountryViewModel.call(self);
        //
        //   self.flow = ko.observable('Private');
        //   self.endPoint = 'Lead';
        //   self.leadSource = 'Web';
        //   self.recordType = CONFIG.sfdc.recordType.LEAD;
        //   self.contactType = 'Extended Primary User';
        //   self.accountType = 'Extended Primary User';
        //   self.status = 'Open';
        //
        //   self.endPointForRepresentative = 'InterestReps';
        //
        //
        //   self.validate = function() {
        //     return self.companyName() !== '' &&
        //       self.companyAddress1() !== '' &&
        //       self.orgCountry() !== '' &&
        //       self.orgCity() !== '' &&
        //       self.orgState() !== '' &&
        //       self.orgPostalCode() !== '' &&
        //       self.companyTel() !== '' &&
        //       self.validatePostalCode(self.orgPostalCode(), self.orgCountry()) &&
        //       self.validateTel(self.companyTel()) &&
        //       self.fname() !== '' &&
        //       self.lname() !== '';
        //
        //   };
        //
        //   self.getRegistrationFlowData = function(data) {
        //     //contact fields
        //     data.orgName = self.companyName();
        //     data.streetAddress = self.companyAddress1();
        //    // data.companyAddress2 = self.companyAddress2();
        //     data.city  = self.orgCity();
        //     data.state = self.orgState();
        //     data.country = self.orgCountry();
        //     data.postalCode = self.orgPostalCode();
        //     data.orgTel = self.companyTel();
        //     data.website = self.companyWebsite();
        //     data.firstName = self.fname();
        //     data.lastName = self.lname();
        //     data.email = self.companyEmail();
        //     data.tel = self.companyPhone();
        //     data.ext = self.telExt();
        //     data.leadSource = self.leadSource;
        //     data.recordTypeId = self.recordType;
        //     data.accountType = self.accountType;
        //     data.contactType = self.contactType;
        //     return data;
        //   };
        //
        //   self.getRepresantativeData = function (data,result) {
        //     data.repName = self.fnatntfname() + " " +self.fnatntlname();
        //     data.repEmail = self.companyfnatntEmail();
        //     data.repPhone = self.companyfnatntPhone();
        //     data.lead = result.id;
        //     return data;
        //   };
        // };
        //
        // var RetireeViewModel = function () {
        //   var self = this;
        //   SageGlobals.registrationViewModel.call(self);
        //   SageGlobals.contactViewModel.call(self);
        //   SageGlobals.stateCountryViewModel.call(self);
        //   SageGlobals.orgStateCountryViewModel.call(self);
        //
        //   self.flow = ko.observable('Retiree');
        //   self.endPoint = 'Contact';
        //   self.leadSource = 'Web';
        //   self.recordType = CONFIG.sfdc.recordType.CONTACT;
        //   self.contactType = 'Retiree';
        //   self.status = 'Not Reviewed';
        //
        //
        //   self.validate = function() {
        //     return self.validateEmail(self.email()) &&
        //       self.orgName() !== '' &&
        //       self.positionOpen() !== '' &&
        //       self.orgCity() !== '' &&
        //       self.orgState() !== '' &&
        //       self.orgCountry() !== '' &&
        //       self.fname() !== '' &&
        //       self.lname() !== '' &&
        //       self.address1() !== '' &&
        //       self.country() !== '' &&
        //       self.city() !== '' &&
        //       self.postalCode() !== '' &&
        //       self.validatePostalCode(self.postalCode(), self.country()) &&
        //       self.validateTel(self.tel());
        //
        //   };
        //
        //   self.getRegistrationFlowData = function(data) {
        //     //contact fields
        //     data.orgName = self.orgName();
        //     data.title = self.positionOpen();
        //     data.orgCity = self.orgCity();
        //     data.orgState = self.orgState();
        //     data.orgCountry = self.orgCountry();
        //     data.firstName = self.fname();
        //     data.lastName = self.lname();
        //     data.streetAddress = self.streetAddress();
        //     data.city = self.city();
        //     data.state = self.state();
        //     data.postalCode = self.postalCode();
        //     data.country = self.country();
        //     data.tel = self.tel();
        //     data.email = self.email();
        //     data.status = self.status;
        //     data.recordTypeId = self.recordType;
        //     data.contactType = self.contactType;
        //
        //     return data;
        //   };
        // };

        ko.bindingHandlers.stopBinding = {
          init: function () {
            return {controlsDescendantBindings: true};
          }
        };
        ko.virtualElements.allowedBindings.stopBindings = true;

        if(document.getElementById('registration-ko-hook')) {
          ko.applyBindings(new ViewModel(flow), document.getElementById('registration-ko-hook'));
        }

        if(document.getElementById('gov-registration')) {
          ko.applyBindings(new GovViewModel(), document.getElementById('gov-registration'));
        }

        // if(document.getElementById('nonprofit-registration')) {
        //   ko.applyBindings(new NonProfitModel(), document.getElementById('nonprofit-registration'));
        // }

        // if(document.getElementById('retiree-registration')) {
        //   ko.applyBindings(new RetireeViewModel(), document.getElementById('retiree-registration'));
        // }

        // if(document.getElementById('private-registration')) {
        //   ko.applyBindings(new PrivateViewModel(), document.getElementById('private-registration'));
        // }
      }
    },

    //Search
    'search': {
      init: function() {
        jQuery('#cover-spin').show(0);
        var queryParams = SageGlobals.getQueryParameters();
        var s = queryParams.hasOwnProperty('s');
//         if(s){
//             jQuery('#cover-spin').hide(0);
//            jQuery('.result').show();
//         }

        $('#contract-search').on('click', ' :checkbox', function() {
          var $this = $(this);

          //reset all categories if top level category chosen
          if($this.data('parent') === true) {
            $('#contract-search [name="cc[]"]').prop('checked', false);
            $this.prop('checked', true);
          }

          //if child category chosen also make sure to check its parent category
          var $parent = $(this).parents('.filter__category');
          if($parent) {
            $parent.find('> label :checkbox').prop('checked', true);
          }

          $('#contract-search').submit();
          jQuery('.result').show();

        });
//       if (window.location.href.indexOf("contract_category") > -1 ||
//                   window.location.href.indexOf("contract_type") > -1) {
//                    $('#contract-search').submit();
//         }
      }
    },
    'page_id_374': {
      init: function () {
        var details_cookie=JSON.parse(SageGlobals.getCookieValue('details'));
        jQuery('#join_fname').val(details_cookie.fname);
        jQuery('#join_lname').val(details_cookie.lname);
        jQuery('#join_email').val(details_cookie.email);
        jQuery('#join_phone').val(details_cookie.phone);
        setTimeout(function () {
          document.cookie = 'details=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        }, 1 * 60 * 1000);

      }
    },
    //Complete Account
    'page_id_783': {
      init: function() {
        var PageViewModel = function() {
          var self = this;
          SageGlobals.formViewModel.call(self);
          //set email verified for Auth0 to true because they already have had to have access to their email to get the url to trigger this flow
          self.verifyEmail = true;
          self.email = ko.observable();
          self.password = ko.observable();
          self.passwordConfirm = ko.observable();
          self.id = ko.observable();
          self.nonce = ko.observable();
          self.name = ko.observable();

          //set emailVerified to true to SFDC as well to match with Auth0
          self.getRegistrationFlowData = function() {
            return {
              emailVerified: true,
              emailVerifiedDate: SageGlobals.getTimeStamp()
            };
          };

          self.validate = ko.pureComputed(function() {
            return self.validateConfirm([self.password(), self.passwordConfirm()]);
          });

          this.register = function() {
            if (self.preSubmit()) {
              var data = {
                'email': self.email(),
                'password': self.password(),
                'id': self.id(),
                'nonce': self.nonce(),
                'name': self.name()
              };

              $.ajax({
                method: 'POST',
                url: '/lib/complete-account.php',
                dataType: 'json',
                data: data
              })
                  .done(function (result) {
                    if(result.success) {
                      window.location.href = result.url;
                    }
                    else {
                      SageGlobals.log({
                        errorSeverity: 'WARNING',
                        error: data,
                        payload: result,
                        description: 'Error creating Contact during Complete Account'
                      });
                      self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
                    }
                  })
                  .fail(function (jqXHR) {
                    SageGlobals.log({
                      errorSeverity: 'WARNING',
                      error: jqXHR,
                      payload: data,
                      description: 'Exception creating Contact during Complete Account'
                    });
                    self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
                  });
            }
          };
        };

        if(document.getElementById('complete-account')) {
          ko.applyBindings(new PageViewModel(), document.getElementById('complete-account'));
        }
      }
    },

    //Impersonate
    'page_id_1219': {
      init: function() {
        var queryParams = SageGlobals.getQueryParameters();
        var email = queryParams.email ? queryParams.email : '';
        var nonce = $('#impersonate-complete-account').val();

        var ImpersonateViewModel = function(email, nonce) {
          var self = this;
          SageGlobals.formViewModel.call(self);

          self.impersonateSubmitText = 'Impersonate User';

          self.foundUser = ko.observable(false);
          self.impersonationWorking = ko.observable(false);
          self.email = ko.observable(email);
          self.fullName = ko.observable('');
          self._email = ko.observable('');
          self.impersonateSubmit = ko.observable(self.impersonateSubmitText);

          self.submitForm = function() {
            if(self.preSubmit()) {
              var queryParams = {
                fields: 'user_id,name,email',
                searchValues: self.email()
              };

              _Auth0.query(queryParams).then(function (result) {
                if(result.success) {
                  var users = result.response;
                  if (users.length) {
                    var impersonatedUser = result.response[0];
                    self.userId = result.response[0].user_id;
                    self.fullName(result.response[0].name);
                    self._email(result.response[0].email);
                    self.foundUser(true);
                    self.setWorking(false);
                    self.resetMessages();
                  }
                  else {
                    SageGlobals.log({
                      errorSeverity: 'NOTICE',
                      error: 'User not found during NPP impersonation',
                      payload: self.email(),
                      description: ''
                    });

                    self.setMessage('error', self.errorClass, 'User not found');
                  }
                }
                else {
                  self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
                }

              }).catch(function (response) {
                SageGlobals.log({
                  errorSeverity: 'WARNING',
                  error: response,
                  payload: self.email(),
                  description: 'Exception querying Auth0 during NPP impersonation'
                });

                self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
              });
            }

          };

          self.impersonate = function() {
            self.impersonationWorking(true);
            self.impersonateSubmit('Working...');
            self._impersonate(self.userId, nonce, '/&impersonate=true');
          };

          self.cancel = function() {
            self.resetMessages();
            self.foundUser(false);
            self._email('');
          };

          self.validate = ko.pureComputed(function() {
            return self.validateEmail(self.email());
          });

          //internal logic to implement impersonation. Use public facing impersonate function to handle requests from UI
          self._impersonate = function(userId, nonce, redirect) {
            //reset messages to avoid repeating error notifications
            self.resetMessages();
            _Auth0.getImpersonationUrl(userId, userId, nonce, redirect).then(function (result) {
              try {
                if (result.success) {
                  //successfully got impersonation url. Send the user to get logged in and redirected to the redirect url
                  window.location.href = result.url;
                }
                else {
                  SageGlobals.log({
                    errorSeverity: 'WARNING',
                    error: result,
                    payload: {userId: userId, imposterId: userId, nonce: nonce},
                    description: 'Error getting impersonation url'
                  });
                  self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
                  self.impersonationWorking(false);
                  self.impersonateSubmit(self.impersonateSubmitText);
                }
              }
              catch (e) {
                SageGlobals.log({
                  errorSeverity: 'WARNING',
                  error: e.message,
                  payload: result,
                  description: 'Failed to parse impersonation ajax response'
                });
                self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
                self.impersonationWorking(false);
                self.impersonateSubmit(self.impersonateSubmitText);
              }
            }).catch(function (response) {
              SageGlobals.log({
                errorSeverity: 'WARNING',
                error: response,
                payload: {userId: userId, imposterId: userId, nonce: nonce},
                description: 'Error thrown from impersonation API call'
              });
              self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
              self.impersonationWorking(false);
              self.impersonateSubmit(self.impersonateSubmitText);
            });
          };
        };

        ko.applyBindings(new ImpersonateViewModel(email, nonce), document.getElementById('impersonate'));
      }
    },

    //Account
    'page_id_1227': {
      init: function() {

        var shadowContact = {
          fname: $('#contact-fname').val(),
          lname: $('#contact-lname').val(),
          position: $('#contact-position').val(),
          tel: $('#contact-tel').val(),
          streetAddress: $('#contact-mailing-street-address').val(),
          city: $('#contact-mailing-city').val(),
          state: $('#contact-mailing-state').val(),
          postalCode: $('#contact-mailing-postalcode').val(),
          country: $('#contact-mailing-country').val(),
          positionOpen: $('#contact-title').val(),
          type: $('#contact-type').val()
        };

        var ViewModel = function() {
          var self = this;
          SageGlobals.formViewModel.call(self);

          self.contactId = ko.observable();
          self.data = {};

          self.isEditing = ko.observable(false);

          self.editButtonText = ko.pureComputed(function() {
            return self.isEditing() ? 'Cancel' : 'Edit';
          });


          self.update = function() {
            if(self.preSubmit()) {
              self.data = self.getRegistrationFlowData(self.data);

              var headers = {
                'X-boomi-set-null': 'yes'
              };

              // var prom = _Boomi.sendRequest('PUT', 'Contact/' + self.contactId(), self.data, headers);
              var prom = callSalesforceApi("/services/apexrest/contact/" + self.contactId(), "PUT", {contact:self.data});
              prom.then(function(result) {
                if (result.success === true) {
                  self.setMessage('success', 'success-messageprofile', 'Your information has been successfully updated.');
                  //refresh member info
                  _Lib.sendRequest('POST', 'refresh-account-info.php', {
                    redirect: window.location.pathname,
                    nonce: $('#request-nonce').val()
                  })
                      .then(function(result) {
                        if(result.success === 'true') {
                          window.location.reload(true);
                        }
                        else {
                          self.isEditing(false);
                        }
                      });

                }
                else {
                  //error
                  SageGlobals.log({
                    errorSeverity: 'WARNING',
                    error: 'Failure to update Account',
                    payload: self.data,
                    description: 'Contact ID: ' + self.contactId()
                  });
                  self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
                }
              })
                  .catch(function(response) {
                    //log exception
                    SageGlobals.log({
                      errorSeverity: 'WARNING',
                      error: 'Exception during during update Account',
                      payload: self.data,
                      description: response
                    });
                    self.setMessage('error', self.errorClass, SageGlobals.GENERIC_ERROR_MSG);
                  });
            }
          };
        };

        var InterestViewModel = function(currentInterests) {
          var self = this;
          SageGlobals.interestsMultiSelectModel.call(self);
          ViewModel.call(self);

          //update interestMultiselect based on existing interests
          self.checkedInterests(currentInterests);
          self.contactId = ko.observable();

          self.toggleEdit = function() {
            self.isEditing(!self.isEditing());

            //if they cancel the edit, reset interests back to origjnal values
            if(!self.isEditing()) {
              self.checkedInterests($('#interests').val().split(';'));
            }
          };

          self.getRegistrationFlowData = function(data) {
            data.interest = self.checkedInterests().join(';');

            return data;
          };
        };

        var ContactViewModel = function(flow, shadowContact) {
          var self = this;
          SageGlobals.contactViewModel.call(self);
          SageGlobals.stateCountryViewModel.call(self);
          SageGlobals.orgStateCountryViewModel.call(self);
          SageGlobals.leadViewModel.call(self);
          ViewModel.call(self);

          self.shadow = shadowContact;
          self.flow = ko.observable(flow);
          self.streetAddress = ko.observable();

          self.toggleEdit = function() {
            self.isEditing(!self.isEditing());

            if(!self.isEditing()) {
              self.setInitialValues(self.shadow);
            }
          };

          self.getRegistrationFlowData = function(data) {
            if(self.flow() === 'Government' || self.flow() === 'Nonprofit') {
              data.firstname = self.fname().trim();
              data.lastname = self.lname();
              data.position = self.position();
              data.tel = self.tel();
            }
            else {
              //Retiree
              data.firstName = self.fname().trim();
              data.lastName = self.lname();
              data.streetAddress = self.streetAddress();
              data.city = self.city();
              data.state = self.state();
              data.postalCode = self.postalCode();
              data.country = self.country();
              data.tel = self.tel();
              data.title = self.positionOpen();
            }

            return data;
          };

          //conditional based on retiree vs govt
          self.validate = function() {
            if(self.type() === 'Retiree') {
              return self.positionOpen() !== '' &&
                  self.fname().trim() !== '' &&
                  self.lname() !== '' &&
                  self.streetAddress() !== '' &&
                  self.country() !== '' &&
                  self.city() !== '' &&
                  self.postalCode() !== '' &&
                  self.validatePostalCode(self.postalCode(), self.country()) &&
                  self.validateTel(self.tel());
            }
            else {
              return self.fname().trim() !== '' &&
                  self.lname() !== '' &&
                  self.position() !== '' &&
                  self.validateTel(self.tel());
            }

          };


          //verify works for retiree & govt
          self.setInitialValues = function(shadow) {
            //very much hard coded for the keys required
            self.fname(shadow.fname.trim());
            self.lname(shadow.lname);
            self.position(shadow.position);
            self.tel(shadow.tel);
            self.streetAddress(shadow.streetAddress);
            self.city(shadow.city);
            self.country(shadow.country);
            self.state(shadow.state);
            self.postalCode(shadow.postalCode);
            self.positionOpen(shadow.positionOpen);
            self.type(shadow.type);
          };
        };

        var contactViewModel = new ContactViewModel($('#flow').val(), shadowContact);
        contactViewModel.setInitialValues(shadowContact);

        var resetPasswordViewModel = new SageGlobals.resetPasswordViewModal();
        resetPasswordViewModel.submit('Update Password');



        if(document.getElementById('account-interest')) {
          ko.applyBindings(new InterestViewModel($('#interests').val().split(';')), document.getElementById('account-interest'));
        }

        if(document.getElementById('account-contact')) {
          ko.applyBindings(contactViewModel, document.getElementById('account-contact'));
        }

        if(document.getElementById('account-reset-form')) {
          ko.applyBindings(resetPasswordViewModel, document.getElementById('account-reset-form'));
        }

      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };
  document.addEventListener('DOMContentLoaded', function() {
    const passwordField = document.querySelector('input[type="password"]');
    const toggleIcon = document.querySelector('.password-toggle-icon');
    const showIcon = document.querySelector('.pass-show');
    const hideIcon = document.querySelector('.pass-hide');

    toggleIcon.addEventListener('click', function() {
      if (passwordField.type === 'password') {
        passwordField.type = 'text';
        showIcon.style.display = 'none';
        hideIcon.style.display = 'inline';
      } else {
        passwordField.type = 'password';
        showIcon.style.display = 'inline';
        hideIcon.style.display = 'none';
      }
    });
    setTimeout(function() {
      const prevButton = document.querySelector('.owl-prev');
      const nextButton = document.querySelector('.owl-next');
  
      // Remove the role attribute
      if (prevButton) {
        console.log('Owl carousel navigation buttons initialized');
        prevButton.removeAttribute('role');
      }
      if (nextButton) {
        console.log('Owl carousel navigation buttons initialized');
        nextButton.removeAttribute('role');
      }
    }, 1000); // Adjust the delay as needed
  });
  // Load Events
  $(document).ready(UTIL.loadEvents);

  // NWD-1266 NPP & NPPGov Site Referral Function
  $(document).ready(function(){
    $('.button--submit').click(function(){
      //$('.ws-po-box').css('display','block');
      var postalCode = $('input[name="org-postal-code"]').attr('aria-invalid');
      var postalVal = $('input[name="org-postal-code"]').val();

      var telCode = $('input[name="orgTel"]').attr('aria-invalid');
      var telVal = $('input[name="orgTel"]').val();

      var phoneCode = $('input[name="tel"]').attr('aria-invalid');
      var phoneVal = $('input[name="tel"]').val();

      if (postalVal !== '' && telVal !== '' && phoneVal !== '') {
        $('.ws-po-box').css('display','block');
      }

      if (postalCode === 'true' && postalVal !== '') {
          // $('.confirm-zip').css('display','block');
          // $('.confirm-zip').delay(5500).fadeOut('fast');
          $('.ws-po-box').css('display','block');
      }else if (telCode === 'true' && telVal !== '') {
          // $('.confirm-phone').css('display','block');
          // $('.confirm-phone').delay(5500).fadeOut('fast');
          $('.ws-po-box').css('display','block');
      }else if (phoneCode === 'true' && phoneVal !== '') {
          // $('.confirm-tel').css('display','block');
          // $('.confirm-tel').delay(5500).fadeOut('fast');
          $('.ws-po-box').css('display','block');
      }else{
        $('.ws-po-box').css('display','block');
      }
    });
    if ($('.wFormContainer a.errMsg').length > 0) {
      console.log('test validate 1234');
      var errorMessage = $('.wFormContainer a.errMsg').html();
      var avoidMessage = " - ";
      if(errorMessage.indexOf(avoidMessage) !== -1){
        //var avoided = errorMessage.replace(avoidMessage,'');
        var avaoided = errorMessage.split(avoidMessage);
        $('.wFormContainer a.errMsg').html(avaoided[1]);
      }
    }

    // owl carousel edits
    var matched = $(".hero-banner-slider .owl-dots button");
    var array = [];
    for(var k=1; k <= matched.length; k++){
      array.push(k);
    }
    console.log(array);
    var el = $.map(array, function(val, i) {
      return '<button class="owl-dot">'+ val +'</button>';
    });
    $(".hero-banner-slider .owl-dots").html(el.join(""));
    $(".hero-banner-slider .owl-dots >button:first-child").addClass('active');
console.log('it is working');
  });

  // Login Metrics Enhancement
  // Add global login metrics tracking functionality
  window.LoginMetrics = window.LoginMetrics || {};
  
  (function(LoginMetrics) {
    var lm = LoginMetrics;
    
    // Initialize timing data storage
    lm.timingData = {
      pageLoadStart: performance.timing.navigationStart,
      pageLoadEnd: Date.now(),
      loginStartTime: null,
      loginEndTime: null,
      auth0RedirectTime: null,
      ajaxCallTime: null,
      totalLoginTime: null,
      userEmail: null,
      success: 1,
      errorMessage: null,
      browserInfo: {
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        language: navigator.language,
        cookieEnabled: navigator.cookieEnabled,
        screenResolution: screen.width + 'x' + screen.height,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        connectionType: navigator.connection ? navigator.connection.effectiveType : 'unknown'
      }
    };
    
    // Method to start login timing
    lm.startLoginTimer = function() {
      lm.timingData.loginStartTime = Date.now();
      lm.timingData.pageRedirectTime = lm.timingData.loginStartTime - lm.timingData.pageLoadStart;
      console.log('Login timer started at:', lm.timingData.loginStartTime);
    };
    
    // Method to end login timing
    lm.endLoginTimer = function() {
      lm.timingData.loginEndTime = Date.now();
      lm.timingData.totalLoginTime = lm.timingData.loginEndTime - lm.timingData.loginStartTime;
      console.log('Login timer ended. Total time:', lm.timingData.totalLoginTime + 'ms');
    };
    
    // Method to log metrics to server
    lm.logMetrics = function(additionalData) {
      // Merge additional data if provided
      if (additionalData) {
        Object.assign(lm.timingData, additionalData);
      }
      
      // Ensure we have required data
      if (!lm.timingData.loginStartTime || !lm.timingData.loginEndTime) {
        console.warn('Login metrics: Missing required timing data');
        return;
      }
      
      // Send metrics to server
      $.ajax({
        url: window.location.origin + '/lib/log-login-metrics.php',
        type: 'POST',
        data: { 
          metrics: JSON.stringify(lm.timingData) 
        },
        success: function(response) {
          console.log('Login metrics logged successfully:', response);
        },
        error: function(xhr, status, error) {
          console.warn('Failed to log login metrics:', error);
        }
      });
    };
    
    // Method to show progressive status messages during login
    lm.showStatusMessage = function(message, type) {
      type = type || 'info';
      var statusElement = $('#login-status-message');
      
      if (statusElement.length === 0) {
        // Create status element if it doesn't exist
        $('body').append('<div id="login-status-message" style="position: fixed; top: 20px; right: 20px; background: #fff; border: 1px solid #ddd; padding: 15px; border-radius: 5px; box-shadow: 0 2px 10px rgba(0,0,0,0.1); z-index: 9999; max-width: 300px;"></div>');
        statusElement = $('#login-status-message');
      }
      
      var colors = {
        info: '#2271b1',
        success: '#00a32a',
        warning: '#f0b849',
        error: '#d63638'
      };
      
      statusElement.html(message).css({
        'border-left': '4px solid ' + (colors[type] || colors.info),
        'display': 'block'
      }).fadeIn();
      
      // Auto-hide info and success messages
      if (type === 'info' || type === 'success') {
        setTimeout(function() {
          statusElement.fadeOut();
        }, 3000);
      }
    };
    
    // Method to track specific login steps
    lm.trackStep = function(stepName, startTime) {
      var endTime = Date.now();
      var duration = endTime - startTime;
      
      console.log('Login step "' + stepName + '" completed in ' + duration + 'ms');
      
      // Store step timing
      lm.timingData[stepName + 'Time'] = duration;
      
      // Show status message
      var messages = {
        'auth0Redirect': 'Redirecting from Auth0...',
        'ajaxCall': 'Processing login credentials...',
        'auth0ProfileFetch': 'Fetching user profile...',
        'salesforceApi': 'Validating account information...',
        'wordpressLoad': 'Loading WordPress...',
        'serverProcessing': 'Finalizing login...'
      };
      
      if (messages[stepName]) {
        lm.showStatusMessage(messages[stepName], 'info');
      }
    };
    
    // Auto-start timing on pages that might be login-related
    $(document).ready(function() {
      // Check if this is a login-related page
      var isLoginPage = window.location.pathname.includes('/lib/login') || 
                       window.location.search.includes('connection=') ||
                       document.body.className.includes('login');
      
      if (isLoginPage) {
        lm.startLoginTimer();
        lm.showStatusMessage('Initializing login process...', 'info');
      }
      
      // Monitor for login form submissions
      $('form[action*="login"]').on('submit', function() {
        lm.startLoginTimer();
        lm.showStatusMessage('Submitting login credentials...', 'info');
      });
    });
    
  })(window.LoginMetrics);

})(jQuery); // Fully reference jQuery after this point.
